import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = () =>  ({
  root: {
      marginBottom: 0,
      borderRadius: 0
  },
});


class PostHolder extends React.Component {
    constructor(props){
        super(props);
        this.state={
            paras: this.props.body
        }
    }

  render(){
    const { classes } = this.props;
    return (
        
            <Typography gutterBottom variant="h5" component="h2">
               Topic:  "{this.props.title}"
            </Typography>
        
    );
    }
}

export default withStyles(styles, {withTheme:true})(PostHolder);
